<template>
  <div class="recharge-bottom-bar" :style="{ 'background-color': bgc }">
    <div class="bar"></div>
  </div>
</template>

<script>
export default {
  name: 'bottomBar',
  data() {
    return {};
  },
  props: {
    bgc: {
      type: String,
      default: '#F5F6F7'
    },
  }
};
</script>

<style lang="less">
.recharge-bottom-bar {
  width: 100%;
  height: 14px;
  .bar {
    margin: 0 auto;
    width:134px;
    height:5px;
    background:rgba(0,0,0,1);
    border-radius:3px;
  }
}
</style>
